/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import {OwnerIdCookie} from "@/core/js/Cookie/OwnerIdCookie";
import {RedirectCookie} from "@/core/js/Cookie/RedirectCookie";
import {ProgramIdCookie} from "@/core/js/Cookie/ProgramIdCookie";
import {ProgramStepIdCookie} from "@/core/js/Cookie/ProgramStepIdCookie";
import {SessionItemIdCookie} from "@/core/js/Cookie/SessionItemIdCookie";
import {ClientIdCookie} from "@/core/js/Cookie/ClientIdCookie";
import {PlanIdCookie} from "@/core/js/Cookie/PlanIdCookie";
import CommonObject from "@shared/CommonObject";
import {SettingsCookie} from "@/core/js/Cookie/SettingsCookie";
import Base64Cookie from "@/core/js/Cookie/Base64Cookie";
import {isObject} from "@/utils/helpers";

export default class Cookie{

	owner = new OwnerIdCookie()
	redirect = new RedirectCookie()
	programId = new ProgramIdCookie()
	programStepId = new ProgramStepIdCookie()
	sessionItemId = new SessionItemIdCookie()
	clientId = new ClientIdCookie()
	planId = new PlanIdCookie()
	settings = new SettingsCookie()

	base64Cookie = new Base64Cookie()


	constructor() {
		this.$cookies = CommonObject.cookies
	}

	set(key, value){
		let str = isObject(value) ? JSON.stringify(value) : value
		console.log("cookie save: value = ", value, ", str = ", str)
		this.$cookies.set(key, str)
	}
	setOnce(key, value){
		if(!this.exists(key)){
			this.set(key, value)
		}
	}
	save(key, value){
		this.set(key, value)
	}
	get(key){
		let value = JSON.parse(this.$cookies.get(key))
		console.log("cookie get: value = ", value)
		return value
	}
	exists(key){
		let res = this.$cookies.isKey(key)
		console.log("cookie exists: key = ", key, ", res = ", res)
		return res
	}
	getAndClear(key){
		let value = this.get();
		this.$cookies.remove(key);
		return value
	}
}



